"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var storeApi = _interopRequireWildcard(require("@/api/store"));
var _validate = require("@/utils/validate");
var _common = require("./common");
var _enum = require("../enum");
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var _default = exports.default = {
  data: function data() {
    return {
      stepsEnum2: _enum.stepsEnum2,
      active: 0,
      submitLoading: false,
      ID: this.$route.params.id,
      form: {},
      childsRefs: [],
      newForm: {}
    };
  },
  created: function created() {
    (0, _common.init)();
    this.handleDetailList();
  },
  mounted: function mounted() {
    this.hasConfirm = null;
    this.childsRefs = [this.$refs.goodsInfoRef, this.$refs.specificationsAndInventoryRef, this.$refs.goodsDetailRef, this.$refs.otherRef];
    if (this.ID) {
      this.setTagsViewTitle();
      this.getInfo();
    }
  },
  methods: {
    handleEdit: function () {
      var _handleEdit = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _this = this;
        var currentForm, specForm;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              try {
                console.log('开始处理编辑保存操作');
                // 先同步当前表单数据
                currentForm = this.newForm && Object.keys(this.newForm).length > 0 ? this.newForm : this.form; // 确保规格数据正确
                if (this.$refs.specificationsAndInventoryRef) {
                  specForm = this.$refs.specificationsAndInventoryRef.form;
                  if (specForm) {
                    if (specForm.attrValue && specForm.attrValue.length > 0) {
                      currentForm.attrValue = specForm.attrValue;
                    }
                    if (specForm.attr && specForm.attr.length > 0) {
                      currentForm.attr = specForm.attr;
                    }
                  }
                }
                console.log('准备保存的表单数据:', currentForm);
                this.$confirm('是否保存本次填写内容', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
                  var res;
                  return _regenerator().w(function (_context) {
                    while (1) switch (_context.n) {
                      case 0:
                        try {
                          res = _this.handleForm(currentForm);
                          console.log('处理后的表单数据:', res);
                          _this.$router.go(-1);
                        } catch (error) {
                          console.error('保存表单时出错:', error);
                          _this.$message.error('保存失败: ' + (error.message || '未知错误'));
                        }
                      case 1:
                        return _context.a(2);
                    }
                  }, _callee);
                }))).catch(function () {
                  console.log('用户取消保存');
                });
              } catch (error) {
                console.error('编辑保存操作出错:', error);
                this.$message.error('处理失败: ' + (error.message || '未知错误'));
              }
            case 1:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function handleEdit() {
        return _handleEdit.apply(this, arguments);
      }
      return handleEdit;
    }(),
    handleDetailList: function () {
      var _handleDetailList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              return _context3.a(2);
          }
        }, _callee3);
      }));
      function handleDetailList() {
        return _handleDetailList.apply(this, arguments);
      }
      return handleDetailList;
    }(),
    formChange: function () {
      var _formChange = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(val) {
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              console.log(val, 'val');
              this.$set(this, 'newForm', val);
              // this.newForm = val
              console.log(this.newForm, 'this.newForm');
            case 1:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function formChange(_x) {
        return _formChange.apply(this, arguments);
      }
      return formChange;
    }(),
    setTagsViewTitle: function setTagsViewTitle() {
      var _this$$route = this.$route,
        path = _this$$route.path,
        fullPath = _this$$route.fullPath,
        query = _this$$route.query,
        params = _this$$route.params,
        name = _this$$route.name,
        meta = _this$$route.meta;
      var route = {
        path: path,
        fullPath: fullPath,
        query: query,
        params: params,
        name: name,
        meta: meta,
        title: "\u7F16\u8F91\u5546\u54C1-".concat(this.ID)
      };
      this.$store.dispatch('tagsView/updateVisitedView', route);
    },
    changeStep: function () {
      var _changeStep = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(n) {
        var _this$childsRefs$this, form, validate, _t;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              _this$childsRefs$this = this.childsRefs[this.active], form = _this$childsRefs$this.form, validate = _this$childsRefs$this.validate;
              if (!(n > 0)) {
                _context5.n = 5;
                break;
              }
              _context5.p = 1;
              _context5.n = 2;
              return validate();
            case 2:
              this.form = form;
              this.active += n;
              _context5.n = 4;
              break;
            case 3:
              _context5.p = 3;
              _t = _context5.v;
              this.$message.warning('请完善必填信息');
            case 4:
              _context5.n = 6;
              break;
            case 5:
              this.form = form;
              this.active += n;
            case 6:
              return _context5.a(2);
          }
        }, _callee5, this, [[1, 3]]);
      }));
      function changeStep(_x2) {
        return _changeStep.apply(this, arguments);
      }
      return changeStep;
    }(),
    handleInfo: function handleInfo() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _ref2 = data || {},
        authMsg = _ref2.authMsg,
        productAttr = _ref2.productAttr,
        cateId = _ref2.cateId,
        productArea = _ref2.productArea,
        labelId = _ref2.labelId,
        channelIds = _ref2.channelIds,
        customerStr = _ref2.customerStr,
        attrValue = _ref2.attrValue,
        brandId = _ref2.brandId,
        brandName = _ref2.brandName,
        isShow = _ref2.isShow,
        sliderImage = _ref2.sliderImage,
        content = _ref2.content,
        image = _ref2.image,
        isBrandAuthorize = _ref2.isBrandAuthorize;
      var info = _objectSpread(_objectSpread({}, data), {}, {
        productAttr: productAttr ? productAttr.split(',') : [],
        brandIdObj: {
          id: brandId,
          brandName: brandName
        },
        isShow: isShow ? 1 : 0,
        authMsg: authMsg ? 1 : 0,
        isBrandAuthorize: isBrandAuthorize !== null ? isBrandAuthorize ? 1 : 0 : null,
        sliderImages: sliderImage ? JSON.parse(sliderImage) : sliderImage,
        cateIds: cateId ? cateId.split(',').map(function (j) {
          return Number(j);
        }) : [],
        // 商品分类id
        areaId: productArea ? productArea.split(',').map(function (j) {
          return Number(j);
        }) : [],
        //产地
        labelId: labelId ? labelId.split(',').map(function (j) {
          return Number(j);
        }) : [],
        //商品标签
        // channelIds: channelIds ? channelIds.split(',').map((j) => Number(j)) : [], //商品标签
        image: image && this.$selfUtil.setDomain(image),
        content: content && this.$selfUtil.replaceImgSrcHttps(content),
        attrValue: attrValue && attrValue.length ? attrValue.map(function (item) {
          var _ref3 = item || {},
            image = _ref3.image,
            attrValue = _ref3.attrValue;
          var imgList = image && image.split(',') || [];
          return _objectSpread(_objectSpread(_objectSpread({}, item), attrValue && JSON.parse(attrValue) || {}), {}, {
            attrValue: attrValue && JSON.parse(attrValue),
            image: imgList && imgList.length && imgList.filter(function (img) {
              return img && img != 0;
            }) || []
          });
        }) : []
      });
      return info;
    },
    getInfo: function () {
      var _getInfo = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var _this2 = this;
        var loading;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              loading = this.$loading({
                lock: true,
                text: '加载中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });
              this.$refs.specificationsAndInventoryRef && this.$refs.specificationsAndInventoryRef.clearInit();
              // try {
              storeApi.productDetailApi2(this.ID).then(function (res) {
                _this2.form = _this2.handleInfo(res);
                loading.close();

                // 数据加载完成后，强制更新各个子组件
                _this2.$nextTick(function () {
                  console.log('商品数据加载完成，准备更新子组件');

                  // 更新规格库存组件
                  if (_this2.$refs.specificationsAndInventoryRef) {
                    console.log('更新规格库存组件数据');
                    // 如果有attr数据，确保规格列表被正确初始化
                    if (_this2.form.attr && _this2.form.attr.length > 0) {
                      _this2.$refs.specificationsAndInventoryRef.selectRuleList = _this2.form.attr.map(function (item) {
                        var _item$attrValues;
                        return {
                          value: item.attrName,
                          detail: item === null || item === void 0 ? void 0 : (_item$attrValues = item.attrValues) === null || _item$attrValues === void 0 ? void 0 : _item$attrValues.split(','),
                          inputVisible: false
                        };
                      });
                    }

                    // 强制更新组件
                    _this2.$refs.specificationsAndInventoryRef.$forceUpdate();
                  }

                  // 通知其他子组件表单数据已更新
                  _this2.childsRefs.forEach(function (ref) {
                    ref && ref.$forceUpdate && ref.$forceUpdate();
                  });
                });
              }).catch(function (err) {
                loading.close();
                console.error('获取商品数据失败:', err);
                _this2.$message.error('获取商品数据失败!');
              });
              // } catch (error) {
              // loading.close();
              // this.$message.error('处理信息失败!');
              // }
            case 1:
              return _context6.a(2);
          }
        }, _callee6, this);
      }));
      function getInfo() {
        return _getInfo.apply(this, arguments);
      }
      return getInfo;
    }(),
    handleForm: function handleForm(form) {
      var _newForm2, _newForm2$brandIdObj;
      var newForm = _objectSpread({}, form);
      var _newForm = newForm,
        _newForm$labelId = _newForm.labelId,
        labelId = _newForm$labelId === void 0 ? [] : _newForm$labelId,
        _newForm$channelIds = _newForm.channelIds,
        channelIds = _newForm$channelIds === void 0 ? [] : _newForm$channelIds,
        _newForm$cateIds = _newForm.cateIds,
        cateIds = _newForm$cateIds === void 0 ? [] : _newForm$cateIds,
        _newForm$areaId = _newForm.areaId,
        areaId = _newForm$areaId === void 0 ? [] : _newForm$areaId,
        _newForm$productAttr = _newForm.productAttr,
        productAttr = _newForm$productAttr === void 0 ? [] : _newForm$productAttr,
        syncList = _newForm.syncList,
        _newForm$attrValue = _newForm.attrValue,
        attrValue = _newForm$attrValue === void 0 ? [] : _newForm$attrValue;
      console.log("handleForm - 原始attrValue数量:", attrValue.length);

      // 检查并去除重复的规格项
      if (attrValue && attrValue.length > 1) {
        var existingSkuCodes = new Set();
        var uniqueAttrs = [];
        attrValue.forEach(function (attr) {
          if (!attr.skuCode || !existingSkuCodes.has(attr.skuCode)) {
            if (attr.skuCode) existingSkuCodes.add(attr.skuCode);
            uniqueAttrs.push(attr);
          } else {
            console.warn("handleForm - 跳过重复的规格项:", attr.skuCode);
          }
        });
        if (uniqueAttrs.length !== attrValue.length) {
          console.log("handleForm - \u89C4\u683C\u53BB\u91CD: ".concat(attrValue.length, " -> ").concat(uniqueAttrs.length));
          attrValue = uniqueAttrs;
        }
      }
      newForm.specType = true;
      newForm.isSub = false;
      newForm.keyword = newForm.storeName;
      if (newForm.sliderImages) {
        newForm.image = newForm.sliderImages[0];
      }
      console.log(newForm.labelId);
      newForm.brandId = (_newForm2 = newForm) === null || _newForm2 === void 0 ? void 0 : (_newForm2$brandIdObj = _newForm2.brandIdObj) === null || _newForm2$brandIdObj === void 0 ? void 0 : _newForm2$brandIdObj.id;
      newForm.labelId = labelId && labelId.length && labelId.join(',');
      // newForm.channelIds = channelIds && channelIds.length && channelIds.join(',');
      newForm.cateId = cateIds && cateIds.length && cateIds.join(',');
      newForm.productArea = areaId && areaId.length && areaId.join(',');
      newForm.productAttr = productAttr && productAttr.length && productAttr.join(',');
      newForm.deliveryTime = newForm.deliveryTime === 'other' ? newForm.deliveryTimeOther : newForm.deliveryTime;
      newForm.sliderImage = JSON.stringify(newForm.sliderImages);
      newForm.attrValue = attrValue && attrValue.length ? attrValue.map(function (item) {
        var _ref4 = item || {},
          image = _ref4.image,
          attrValue = _ref4.attrValue;
        return _objectSpread(_objectSpread({
          id: 0,
          productId: 0
        }, item), {}, {
          image: image && image.length && image.join(','),
          attrValue: attrValue ? JSON.stringify(attrValue) : ''
        });
      }) : [];
      console.log("handleForm - 处理后attrValue数量:", newForm.attrValue.length);
      newForm.brandIdObj && delete newForm.brandIdObj;
      newForm.cateIds && delete newForm.cateIds;
      if (newForm && newForm.productType == 3) {
        var couponSkuInfo = this.$refs.specificationsAndInventoryRef && this.$refs.specificationsAndInventoryRef.couponSkuInfo;
        var _ref5 = couponSkuInfo || {},
          listStatus = _ref5.listStatus,
          attrImage = _ref5.attrImage,
          skuCode = _ref5.skuCode,
          cpStatus = _ref5.cpStatus,
          id = _ref5.id,
          _ref5$image = _ref5.image,
          image = _ref5$image === void 0 ? [] : _ref5$image,
          otPrice = _ref5.otPrice,
          skuName = _ref5.skuName,
          stock = _ref5.stock,
          stockWarning = _ref5.stockWarning,
          supplyPrice = _ref5.supplyPrice,
          suk = _ref5.suk,
          couponId = _ref5.couponId,
          defaultPrice = _ref5.defaultPrice,
          guidePrice = _ref5.guidePrice,
          barCode = _ref5.barCode;
        var _ref6 = newForm || {},
          _ref6$attr = _ref6.attr,
          attr = _ref6$attr === void 0 ? [] : _ref6$attr,
          _ref6$attrValue = _ref6.attrValue,
          _attrValue = _ref6$attrValue === void 0 ? [] : _ref6$attrValue;
        var attrInfo = {
          attrImage: attrImage,
          skuCode: skuCode,
          cpStatus: cpStatus,
          barCode: barCode,
          id: _attrValue && _attrValue.length && _attrValue[0].id,
          image: image.length && image.join(','),
          attrValue: JSON.stringify({
            '规格': suk
          }),
          cpMinQuantity: 0,
          cpSupplyPrice: 0,
          // grossMargin: ,
          listStatus: listStatus,
          defaultPrice: defaultPrice,
          guidePrice: guidePrice,
          otPrice: otPrice,
          skuName: skuName,
          stock: stock,
          stockWarning: stockWarning,
          supplyPrice: supplyPrice
        };
        var couponSkuAttr = [{
          attrName: '规格',
          attrValues: suk,
          id: attr && attr.length && attr[0].id,
          productId: newForm.id
        }];
        newForm = _objectSpread(_objectSpread({}, newForm), {}, {
          couponId: couponId,
          attr: couponSkuAttr,
          attrValue: [attrInfo]
        });
      }
      return newForm;
    },
    submit: (0, _validate.Debounce)(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
      var _submitForm$attrValue,
        _this3 = this;
      var submitForm, specInventoryForm, existingSkuCodes, uniqueAttrs, validationResults, isAllValid, params, invalidSteps, firstInvalidStep, specStepIndex, _t2;
      return _regenerator().w(function (_context7) {
        while (1) switch (_context7.p = _context7.n) {
          case 0:
            submitForm = this.childsRefs[this.active] && this.childsRefs[this.active].form;
            console.log("初始 submitForm:", (submitForm === null || submitForm === void 0 ? void 0 : (_submitForm$attrValue = submitForm.attrValue) === null || _submitForm$attrValue === void 0 ? void 0 : _submitForm$attrValue.length) || 0, "个规格项");
            console.log(this.$refs.specificationsAndInventoryRef.form);
            _context7.p = 1;
            // 规格库存特殊处理，确保规格库存数据是最新的并且没有重复
            if (this.active === 1 && this.$refs.specificationsAndInventoryRef) {
              console.log("当前在规格库存步骤，获取最新数据");
              specInventoryForm = this.$refs.specificationsAndInventoryRef.form;
              if (specInventoryForm && specInventoryForm.attrValue && specInventoryForm.attrValue.length > 0) {
                console.log("规格组件数据:", specInventoryForm.attrValue.length, "个规格项");

                // 检查是否有重复的SKU编码
                existingSkuCodes = new Set();
                uniqueAttrs = [];
                specInventoryForm.attrValue.forEach(function (attr) {
                  if (!attr.skuCode || !existingSkuCodes.has(attr.skuCode)) {
                    if (attr.skuCode) existingSkuCodes.add(attr.skuCode);
                    uniqueAttrs.push(attr);
                  } else {
                    console.warn("跳过重复的规格项:", attr.skuCode);
                  }
                });
                if (uniqueAttrs.length !== specInventoryForm.attrValue.length) {
                  console.log("\u89C4\u683C\u53BB\u91CD: ".concat(specInventoryForm.attrValue.length, " -> ").concat(uniqueAttrs.length));
                  submitForm.attrValue = uniqueAttrs;
                } else {
                  submitForm.attrValue = specInventoryForm.attrValue;
                }
                console.log("处理后数据:", submitForm.attrValue.length, "个规格项");
              }
            }

            // 改进验证流程，收集详细的验证错误信息
            _context7.n = 2;
            return Promise.all(this.childsRefs.map(function (item, index) {
              if (!item) return {
                isValid: true,
                step: index
              };
              return item.validate().then(function () {
                return {
                  isValid: true,
                  step: index
                };
              }).catch(function (err) {
                console.error("\u6B65\u9AA4".concat(index + 1, "(").concat(_this3.stepsEnum2[index].label, ")\u9A8C\u8BC1\u5931\u8D25:"), err);
                return {
                  isValid: false,
                  step: index,
                  error: err,
                  label: _this3.stepsEnum2[index].label
                };
              });
            }));
          case 2:
            validationResults = _context7.v;
            isAllValid = validationResults.every(function (result) {
              return result.isValid;
            });
            if (isAllValid) {
              this.submitLoading = true;
              params = this.handleForm(submitForm);
              console.log('提交参数:', params);

              // 检查规格库存相关字段
              if (params.attrValue && Array.isArray(params.attrValue)) {
                console.log('规格库存数据:', params.attrValue);
              }
              storeApi[this.ID ? 'productUpdateSupplierApi' : 'productCreateSupplierApi'](_objectSpread(_objectSpread({}, params), {}, {
                id: this.ID
              }), this.hasConfirm ? {
                hasConfirm: this.hasConfirm
              } : {}).then(function (res) {
                _this3.submitLoading = false;
                _this3.$message.success('操作成功！');
                if (_this3.ID) {
                  var searchForm = sessionStorage.getItem('SPU_SEARCH_FORM') || "{}";
                  searchForm = JSON.parse(searchForm) || {};
                  sessionStorage.setItem('SPU_SEARCH_FORM', JSON.stringify(_objectSpread(_objectSpread({}, searchForm), {}, {
                    isEdit: 1
                  })));
                }
                ;
                setTimeout(function () {
                  _this3.$router.push({
                    path: '/store/goodsManage/spu2'
                  });
                }, 300);
              }).catch(function (err) {
                var _ref8 = err && err.data || {},
                  code = _ref8.code,
                  msg = _ref8.msg;
                _this3.submitLoading = false;
                if (code == 601 && !_this3.hasConfirm) {
                  storeApi.checkComfirm(msg).then(function (res) {
                    _this3.hasConfirm = res && res.hasConfirm;
                    _this3.submit();
                  });
                }
              });
            } else {
              // 显示详细的验证错误信息
              invalidSteps = validationResults.filter(function (result) {
                return !result.isValid;
              }).map(function (result) {
                return result.label;
              }); // 定位到第一个验证失败的步骤
              firstInvalidStep = validationResults.findIndex(function (result) {
                return !result.isValid;
              });
              if (firstInvalidStep !== -1 && firstInvalidStep !== this.active) {
                this.active = firstInvalidStep;
                this.$message.warning("\u5DF2\u5207\u6362\u5230\u6709\u9519\u8BEF\u7684\u6B65\u9AA4: ".concat(this.stepsEnum2[firstInvalidStep].label));
              } else {
                this.$message.error("\u4EE5\u4E0B\u6B65\u9AA4\u5B58\u5728\u5FC5\u586B\u9879\u672A\u586B\u5199: ".concat(invalidSteps.join(', ')));
              }

              // 如果是规格库存验证失败，尝试获取详细信息
              specStepIndex = this.stepsEnum2.findIndex(function (step) {
                return step.label === '规格库存';
              });
              if (specStepIndex !== -1 && !validationResults[specStepIndex].isValid) {
                console.log('规格库存表单数据:', this.childsRefs[specStepIndex].form);
              }
            }
            _context7.n = 4;
            break;
          case 3:
            _context7.p = 3;
            _t2 = _context7.v;
            console.error('验证过程发生错误:', _t2);
            this.$message.error('表单验证失败，请检查所有必填项');
          case 4:
            return _context7.a(2);
        }
      }, _callee7, this, [[1, 3]]);
    })))
  }
};